<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.AddonDialog.AddonHeadline' | translate : 'Addon' }}">
    <mat-tab-group>
      <mat-tab label="{{ 'Turbo.Settings.AddonDialog.GeneralHeadline' | translate : 'General settings' }}">
        <div class="row">
          <div class="col-12" *ngIf="false && addonToSave.IsHidden">
            {{ 'Turbo.Settings.AddonDialog.InactiveInformation' | translate }}
          </div>
          <div class="col-12 mt-2">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.Customers.Table_Name' |translate : 'Name' }}</mat-label>
              <input matInput placeholder="Name" [(ngModel)]="addonToSave.Title" [disabled]="!data.editable">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'Turbo.Settings.AddonDialog.Description' | translate : 'Description' }}</mat-label>
              <input matInput placeholder="Description" [(ngModel)]="addonToSave.Description" [disabled]="!data.editable">
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="this.Settings.isInAny(['Admin'], true)">
              <mat-label>Check condition (dev)</mat-label>
              <input matInput placeholder="Check condition (dev)" [(ngModel)]="addonToSave.CheckCondition" [disabled]="!data.editable">
            </mat-form-field>
          </div>
          <div class="col-4">
            <mat-form-field appearance="outline" style="width: 120px">
              <mat-label>{{ 'Turbo.Settings.AddonDialog.Vat' | translate : 'Vat' }}</mat-label>
              <input matInput placeholder="{{ 'Turbo.Settings.AddonDialog.Vat' | translate : 'Vat' }}" maxlength="3" width="50" [(ngModel)]="addonToSave.VATPercentage" [disabled]="!data.editable">
              <mat-icon matSuffix>%</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-8">
            <label style="margin-top: 10px" class="turboLabel">{{ 'turbo.Settings.EditCategoryDialog.lblSortOrder' | translate : 'Sort order' }}: </label>
            <mat-slider min="0" max="100" step="1"  discrete style="margin-top: 10px; width: 250px" [disabled]="!data.editable">
              <input matSliderThumb [(ngModel)]="addonToSave.SortOrder"/>
            </mat-slider>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-4">
                <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.IsDefault">{{ 'Turbo.Settings.AddonDialog.IsDefault' | translate : 'Selected by default' }}</mat-checkbox>
              </div>
              <div class="col-4">
                <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.ExcludeFromCalculation">{{ 'Turbo.Settings.AddonDialog.ExcludeFromCalc' | translate : 'Exclude from calculation' }}</mat-checkbox>
              </div>
              <div class="col-4">
                <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.UnlimitedAvailability">{{ 'Turbo.Settings.AddonDialog.UnlimitedAvailability' | translate : 'Unlimited availability' }}</mat-checkbox>
              </div>
              <div class="col-4">
                <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.IsInsurance">{{ 'Turbo.Settings.AddonDialog.IsInsurance' | translate : 'Is insurance' }}</mat-checkbox>
              </div>
              <div class="col-4">
                <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.AskIfNotSelected">{{ 'Turbo.Settings.AddonDialog.AskForConfirmation' | translate : 'Ask for confirmation if unchecked' }}</mat-checkbox>
              </div>
              <div class="col-4">
                <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.IsHidden">{{ 'Turbo.Settings.AddonDialog.IsHidden' | translate : 'Hidden' }}</mat-checkbox>
              </div>
              <div class="col-4">
                <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.IsRefundable">{{ 'Turbo.Settings.AddonDialog.IsRefundable' | translate : 'Is refundable' }}</mat-checkbox>
              </div>
              <div class="col-4">
                <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.IncludeCostInRentReceiptLine">{{ 'Turbo.Settings.AddonDialog.IncludeInRentLine' | translate : 'Include in rent line in receipt' }}</mat-checkbox>
            </div>
            </div>
          </div>
        </div>

</mat-tab>
      <mat-tab label="{{ 'Turbo.Settings.AddonDialog.ConnectionsHeadline' | translate : 'Connections' }}">
        <div class="row">
          <div class="col-6" *ngIf="(data.inheritedAddons && data.inheritedAddons.length > 0 && data.editable) || !data.editable && addonToSave.OverridesType && addonToSave.OverridesType.length > 0">
            <p style="font-weight: bold; margin-bottom: 0;">{{ 'Turbo.Settings.AddonDialog.Overrides' | translate : 'Overrides' }}</p>
            <mat-form-field appearance="outline" *ngIf="data.inheritedAddons && data.inheritedAddons.length > 0">
              <mat-label>{{ 'Turbo.Settings.AddonDialog.Overrides' | translate : 'Overrides' }}</mat-label>
              <mat-select [value]="addonToOverride" (selectionChange)="setFromOverride($event)" [disabled]="!data.editable">
                <mat-option *ngFor="let addon of data.inheritedAddons" [value]="addon">
                  <span *ngIf="addon.Title.includes('Turbo.')">
                    {{ addon.Title | translate }}
                  </span>
                  <span *ngIf="!addon.Title.includes('Turbo.')"> {{ addon.Title }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6" *ngIf="(data.allAddons && data.allAddons.length > 0 && data.editable) || !data.editable && addonToSave.ReplacementFor && addonToSave.ReplacementFor.length > 0">
            <p style="font-weight: bold; margin-bottom: 0;">{{ 'Turbo.Settings.AddonDialog.ReplacementFor' | translate : 'Replacement for' }}</p>
            <mat-form-field appearance="outline" *ngIf="data.allAddons && data.allAddons.length > 0 && data.editable">
              <mat-label>{{ 'Turbo.Settings.AddonDialog.Replaces' | translate : 'Replaces' }}</mat-label>
              <mat-select [(ngModel)]="replacements" (selectionChange)="setReplacements($event)" [disabled]="!data.editable" multiple>
                <mat-option *ngFor="let addon of data.allAddons" [value]="addon">
                  <span *ngIf="addon.Title.includes('Turbo.')">
                    {{ addon.Title | translate }}
                  </span>
                  <span>
                    <span *ngIf="!addon.Title.includes('Turbo.')"> {{ addon.Title }}</span>
                  </span>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="!data.editable">
              <div *ngFor="let r of replacements">
                <span *ngIf="r.Title.includes('Turbo.')">
                  {{ addon.Title | translate }}
                </span>
                <span *ngIf="!r.Title.includes('Turbo.')"> {{ r.Title }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-3">
            <mat-checkbox [disabled]="!data.editable" [(ngModel)]="addonToSave.UnlimitedRelations" #unlimited (change)="selectAllRelations(unlimited.checked)">{{ 'Turbo.Settings.AddonDialog.UnlimiteRelations' | translate : 'Use for all models' }}</mat-checkbox>
          </div>
          <div class="col-12" [ngClass]="addonToSave.UnlimitedRelations || !data.editable ? 'not-clickable' : 'clickable'">
            <t4-data-table #tblContent [allowMultiSelect]="true" [rawData]="objectTypes" headline="" matSort matSortActive="Title" [allowPaging]="false" [allowFilter]="false" [allowAdd]="false" [autoGenerateColumns]="false">
              <ng-container matColumnDef="Title">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.EditCategoryDialog.colTitle' | translate : 'Title' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">
                  <ng-container>{{ row.Title }}</ng-container>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Alias">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.EditCategoryDialog.colAlias' | translate : 'Alias' }}</mat-header-cell>
                <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">
                  <ng-container>{{ row.Alias }}</ng-container>
                </mat-cell>
              </ng-container>
            </t4-data-table>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions *ngIf="data.editable">
  <button mat-raised-button color="primary" style="margin: 5px;" [disabled]="!addonToSave.Title" (click)="save()">{{ 'T4.Settings.CreatePricelistDialog.cmdSave' | translate : 'Save' }}</button>
  <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.CreatePricelistDialog.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="!data.editable">
  <button mat-raised-button color="primary" style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.CreatePricelistDialog.cmdClose' | translate : 'Close' }}</button>
</mat-dialog-actions>
